import * as Api from "../api/merchant.js";

export const getMerchants = async (token, callback) => {
	try {
		const { data } = await Api.getMerchants(token);
		callback(data);
	} catch (error) {
		console.log("getMerchants error", error);
	}
};
